module.exports = "https://cdn2-fs.clearscore.com/flux/images/c3360c91194f66bcb9d77ec07d0d5fbd.jpg";